import { WSTimelineItemProps } from "@wingspanhq/fe-component-library";
import { components } from "../../../services/api/resourceEvents/types";
import { EventContent } from "./EventContent";

export function eventToTimeline(
  event: components["schemas"]["IResourceEvent"],
  isCompact?: boolean
): WSTimelineItemProps {
  const actorName = event.userName || "Automated";

  return {
    content: <EventContent isCompact={isCompact} event={event} />,
    date: event.timestamp,
    dateFormat: "default",
    avatar: event.userName
      ? {
          type: "text",
          text: actorName
            .split(" ")
            .map((w: string) => w[0])
            .join("")
        }
      : {
          type: "icon",
          icon: "bot"
        },
    pills: [actorName]
  };
}
